/**
 * 戻るボタン
 */

import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
};

const PrevButton = ({ children, onClick, disabled = false, ...restProps }: Props) => {
  return (
    <button
      type='button'
      className='flex items-center gap-2 py-[8px] text-xs transition-opacity hover:opacity-60'
      onClick={onClick}
      disabled={disabled}
      {...restProps}
    >
      <svg
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5.16667 6L9 9.83333L7.83333 11L2.83333 6L7.83333 1L9 2.16667L5.16667 6Z'
          fill='#292929'
        />
      </svg>
      {children}
    </button>
  );
};

export default PrevButton;
